var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoFavourites24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_favourites_24x24",
    transform: "translate(-3.999 -3.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M1061.41,430.558a1.5,1.5,0,0,1-.724-.189l-3.263-1.784-3.269,1.785a1.516,1.516,0,0,1-1.908-.389,1.628,1.628,0,0,1-.34-1.317l.621-3.774-2.638-2.684a1.649,1.649,0,0,1-.452-.922,1.605,1.605,0,0,1,1.313-1.83l3.646-.55,1.635-3.445a1.523,1.523,0,0,1,2.781,0l1.631,3.443,3.652.552a1.57,1.57,0,0,1,1.25,1.1,1.66,1.66,0,0,1-.391,1.653h0l-2.641,2.677.623,3.785a1.629,1.629,0,0,1-.341,1.311,1.527,1.527,0,0,1-1.185.579Zm-3.989-2.952a.935.935,0,0,1,.437.1l3.267,1.789a.6.6,0,0,0,.751-.155.627.627,0,0,0,.134-.509l-.626-3.785a1.011,1.011,0,0,1,.275-.875l2.64-2.675a.656.656,0,0,0,.009-.9.592.592,0,0,0-.347-.183l-3.647-.553a.945.945,0,0,1-.713-.533l-1.631-3.447a.6.6,0,0,0-1.092,0l-1.632,3.444a.947.947,0,0,1-.714.539l-3.645.55a.617.617,0,0,0-.491.432.653.653,0,0,0,.153.65l2.636,2.677a1.013,1.013,0,0,1,.272.873l-.622,3.78a.626.626,0,0,0,.13.51.6.6,0,0,0,.757.157l3.259-1.784a.935.935,0,0,1,.439-.107Z",
    transform: "translate(-1045.422 -410.56)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoFavourites24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_favourites_24x24.0e34c90a3b6975faec5b36a08b58a502.svg";